import { Roles } from '@/enums/Roles.ts'
import i18n from '@/libs/i18n'
import type { NavLink } from '@/types/Navigation'

const { t } = i18n.global

/*
* Usage of requiredRoles:
* {label: "Example", icon: 'pi pi-fw pi-chart-bar', to: 'example', requiredRoles: [Roles.Global]},
*/

export const getNavItems = (): NavLink[] => {
    return [
        {
            items: [
                { label: t('general.dashboard'), icon: 'pi pi-fw pi-chart-bar', to: 'dashboard' },
                { label: t('user.users'), icon: 'pi pi-fw pi-user', to: 'users' },
                {
                    label: t('channel.channel', 2),
                    icon: 'pi pi-fw pi-play-circle',
                    items: [
                        { label: t('channel_category.channel_categories'), to: 'channel-categories' },
                        { label: t('channel.channel', 2), to: 'channels' },
                        { label: t('channel.sort_channels', 2), to: 'sort-channels' },
                        { label: t('channel_package.channel_packages'), to: 'channel-packages' }
                    ]
                },
                {
                    label: t('live_media.title'),
                    icon: 'pi pi-fw icon-cast',
                    items: [
                        {
                            label: t('live_media.profile'),
                            icon: 'pi pi-fw pi-circle',
                            items: [
                                {
                                    label: t('live_media.video_profile'),
                                    icon: 'pi pi-fw pi-circle',
                                    to: 'live-media-video-profiles'
                                },
                                {
                                    label: t('live_media.audio_profile'),
                                    icon: 'pi pi-fw pi-circle',
                                    to: 'live-media-audio-profiles'
                                }
                            ]
                        },
                        { label: t('live_media.source'), icon: 'pi pi-fw pi-circle', to: 'live-media-sources' }
                    ]
                },
                { label: t('epg.providers'), icon: 'pi pi-fw pi-caret-right', to: 'epg-providers' },
                { label: t('tls_configuration.configuration', 2), icon: 'pi pi-fw icon-lock', to: 'tls-configurations' },
                { label: t('distribution_zone.distribution_zones'), icon: 'pi pi-fw pi-globe', to: 'distribution-zones' },
                { label: t('client.clients'), icon: 'pi pi-fw pi-user', to: 'clients' },
                {
                    label: t('worker.workers'),
                    icon: 'pi pi-fw pi-microchip',
                    to: 'workers'
                },
                { label: t('api_key.api_keys'), icon: 'pi pi-fw pi-key', to: 'api-keys' },
                { label: t('global_drm.global_drm'), icon: 'pi pi-fw pi-server', to: 'global-drm', requiredRoles: [Roles.GlobalDRMConfigurationRead] },
                { label: t('settings.settings'), icon: 'pi pi-fw pi-cog', to: 'settings' }
            ]
        }
    ]
}
